
import { FormLike } from "winfakt-vue-components/src/mixins/form-like";
import {MaxDocumentsMetaData} from "@/models/module-max-documents-meta-data";
import { PlanModule } from "@/models/plan-module";

export default FormLike.extend({
	data(){
		return {
			maxDocuments: 0,
		};
	},
	props: {
		value: {
			type: Object as ()=>PlanModule,
			required: true
		},
	},
	watch: {
		value: {
			immediate: true,
			handler(){
				this.maxDocuments = MaxDocumentsMetaData.create(this.value.MetaData).getMaxDocumentsPerMonth();
			}
		}
	},
	methods: {
		confirm(){
			if (!this.isValid) return;
			MaxDocumentsMetaData.create(this.value.MetaData).setMaxDocumentsPerMonth(this.maxDocuments);
			this.$emit("close");
		}
	}
});
